import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SafetyCone = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 24.0002H23.643L18.2241 3.70818C18.0933 3.21824 17.8043 2.7852 17.4022 2.47632C17 2.16744 16.507 2 15.9999 2C15.4928 2 14.9999 2.16744 14.5977 2.47632C14.1955 2.7852 13.9066 3.21824 13.7758 3.70818L8.357 24.0002H7C6.20435 24.0002 5.44129 24.3163 4.87868 24.8789C4.31607 25.4415 4 26.2045 4 27.0002C4 27.7958 4.31607 28.5589 4.87868 29.1215C5.44129 29.6841 6.20435 30.0002 7 30.0002H25C25.7956 30.0002 26.5587 29.6841 27.1213 29.1215C27.6839 28.5589 28 27.7958 28 27.0002C28 26.2045 27.6839 25.4415 27.1213 24.8789C26.5587 24.3163 25.7956 24.0002 25 24.0002ZM13.0975 14.0002H18.9025L19.9706 18.0002H12.0294L13.0975 14.0002ZM15.708 4.22443C15.7251 4.1601 15.7631 4.10323 15.8159 4.06266C15.8686 4.02209 15.9334 4.0001 15.9999 4.0001C16.0665 4.0001 16.1312 4.02209 16.184 4.06266C16.2368 4.10323 16.2747 4.1601 16.2919 4.22443L18.3684 12.0002H13.6316L15.708 4.22443ZM11.4952 20.0002H20.5047L21.5729 24.0002H10.4271L11.4952 20.0002ZM25 28.0002H7C6.73478 28.0002 6.48043 27.8948 6.29289 27.7073C6.10536 27.5198 6 27.2654 6 27.0002C6 26.735 6.10536 26.4806 6.29289 26.2931C6.48043 26.1055 6.73478 26.0002 7 26.0002H25C25.2652 26.0002 25.5196 26.1055 25.7071 26.2931C25.8946 26.4806 26 26.735 26 27.0002C26 27.2654 25.8946 27.5198 25.7071 27.7073C25.5196 27.8948 25.2652 28.0002 25 28.0002Z" />
	</svg>
);

export default SafetyCone;
